  // the version used in the server code relies on a Node crypto module, so different one here
  //
  // https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid#2117523
  // XXX uuid-browser in frontend deps now.. dedup..
  export function uuidv4() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

export function parseUri(uri) {
  // URI format set in post-upload/index.js
  var obj = {
    scope: "sub",
    ident: null,
    source: null,
    stamp: null,
    stage: null,
  }
  if (uri.indexOf("sinc:sub:") == 0) {
    var bits = uri.split(":");
    // "sinc:sub::cfa5383d-1ca4-4b83-96e9-b0dd16f65ddc:2020-12-23T14:28:57_544Z:001-raw".split(":").forEach(x=>console.log(x))
    // 0 sinc
    // 1 sub
    // 2 
    // 3 cfa5383d-1ca4-4b83-96e9-b0dd16f65ddc
    // 4 2020-12-23T14
    // 5 28
    // 6 57_544Z
    // 7 001_raw
    //key = "sub-"+jwt.sub+"/"+bits[3]+"/"+bits[4]+":"+bits[5]+":"+bits[6]+"/"+bits[7];
    obj.scope=bits[1];
    obj.ident=bits[2].length ? bits[2] : null;
    obj.source=bits[3];
    obj.stamp=bits[4]+":"+bits[5]+":"+bits[6];
    obj.stage=bits[7];
  } else {
    // uri: "sinc:sub//"+data.id+"/"+info.uploadTimestamp+"/"+info.stage
    var bits = uri.substring(5).split("/");
    obj.scope=bits[0];
    obj.ident=bits[1].length ? bits[1] : null;
    obj.source=bits[2];
    obj.stamp=bits[3];
    obj.stage=bits[4];
  }
  return obj;
}